// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"6b565f8d","63":"82218df9","74":"e163fc9e","239":"198fa455","410":"fb234cdb","453":"c7120b5a","719":"3684dcf7"}[chunkId] + ".chunk.js";
};